// Admin auth helpers for frontend.
// Define which emails should be treated as admin users.
// Update ADMIN_EMAILS to match your real admin login(s).

const ADMIN_EMAILS = ['admin@bujji.in'];

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  return ADMIN_EMAILS.map(e => e.trim().toLowerCase()).includes(normalized);
}

// Temporary Cognito admin auth helper for frontend.
// Reads a bearer token from localStorage so we can call protected
// /admin/* APIs while Supabase Auth is restricted.
//
// To use:
//   1) Obtain a Cognito access token for your admin user.
//   2) In the browser console, run:
//        localStorage.setItem('COGNITO_ADMIN_TOKEN', '<your-jwt>');
//   3) Reload the Admin UI. All admin fetch() calls will include:
//        Authorization: Bearer <your-jwt>
//
// Remove this file and its imports when you fully migrate auth.

export function getAdminAuthHeaders(): Record<string, string> {
    try {
      const token = window.localStorage.getItem('COGNITO_ADMIN_TOKEN');
      if (!token) {
        return {};
      }
      return { Authorization: `Bearer ${token}` };
    } catch {
      return {};
    }
  }
  